export type CategoryFilter =
  | 'TODAS'
  | 'Cinemática'
  | 'Dinâmica'
  | 'Energia'
  | 'Termologia'
  | 'Eletricidade'
  | 'Função Quadrática'
  | 'Geometria';

export const CATEGORIES: CategoryFilter[] = [
  'TODAS',
  'Cinemática',
  'Dinâmica',
  'Energia',
  'Termologia',
  'Eletricidade',
  'Função Quadrática',
  'Geometria',
];

export type ActiveTab = 'SOLVER' | 'CATALOG' | 'REVIEW_QUEUE';
